import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { getGarmentPack } from "../../../services/GarmentCategory/GarmentCategory";
import GarmentPackCreateModal from "./GarmentPackCreateModal";
import AdminMenu from "../../AdminMenu";


const GarmentPack = () => {
  const navigate = useNavigate();
  const [selectedItemValue, setSelectedItemValue] = useState(null);
  const [garmentPackData, setGarmentPackData] = useState([]);

  const [visible, setVisible] = useState(false);

  const { brandProfileData } = getUserData();
  let brandId = brandProfileData.id;
  const isWareHouseModel = brandProfileData.wareHouseModel;
  const [loading, setLoading] = useState(false);

  const fetchGarmentPack = () => {
    setLoading(true);
    getGarmentPack(brandId)
      .then(response => {
        if (!response.data.error) {
          const res = response.data;
          setGarmentPackData(res);
          setLoading(false);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };

  useEffect(() => {
    fetchGarmentPack();
  }, []);


  const [garmentPackCreateModalVisible, setGarmentPackCreateModalVisible] =
    useState(false);

  const receiveDataFromGarmentPackCreateModal = ({success}) => {
    if (success) {
      fetchGarmentPack();
      setSelectedItemValue(null);
    }
  };

  const renderCardGarmentPackItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Name :
                  </p>
                  <p className="text-lg font-medium capitalize">{item.name}</p>
                </div>
                 
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div>
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Status :
                  </p>
                  {item.status === true ? (
                    <div className="flex">
                      <p className="text-lg font-medium capitalize mr-2">
                        Active{" "}
                      </p>
                      <img
                        src={
                          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                        }
                      />
                    </div>
                  ) : (
                    <div className="flex">
                      <p className="text-lg font-medium capitalize mr-2">
                        DeActive{" "}
                      </p>
                      <img
                        src={
                          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                        }
                      />
                    </div>
                  )}
                  </div>
                  <div
                    className="mr-4 mt-2"
                    onClick={() => {
                      setGarmentPackCreateModalVisible(true);
                      setSelectedItemValue(item); 
                    }}
                  >
                    <i
                      className="pi pi-pencil"
                      style={{
                        fontSize: "20px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
              Packing Type List
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div
          className="flex-1  surface-0"
          style={{ "--surface-0": "#EAEFF5" }}
        >
          <div className="flex justify-content-between mx-4">
            <div className="py-1">
              <p className=" text-2xl  font-bold ">Garment Pack</p>
            </div>
            <div
              className="flex justify-content-center align-items-center cursor-pointer mr-4"
              onClick={() => {
                setGarmentPackCreateModalVisible(true);
        setSelectedItemValue(null);
              }}
            >
              <img
                src="images/plus.png"
                alt="plus"
                style={{ width: 30 }}
              />
            </div>
          </div>
        </div>
      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : (
          <div>
            <div>
              {garmentPackData?.length > 0 ? (
                <div>
                  <div>{renderCardGarmentPackItem(garmentPackData)}</div>
                </div>
              ) : (
                <div>
                  <p className="text-xl font-medium">No Garment Pack Found</p>
                </div>
              )}
            </div>
            
          </div>
        )}
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />

      <GarmentPackCreateModal
          setGarmentPackCreateModalVisible={setGarmentPackCreateModalVisible}
          garmentPackCreateModalVisible={garmentPackCreateModalVisible}
          sendDataToGarmentPackCreateModal={
            receiveDataFromGarmentPackCreateModal
          }
          brandId={brandId}
          selectedItemValue={selectedItemValue}
        />
    </div>
  );
};

export default GarmentPack;
